import React from 'react';

export interface CropData {
  x: number;
  y: number;
  width: number;
  height: number;
  naturalWidth: number;
  naturalHeight: number;
}

export function parseCropHash(url?: string): { cleanUrl: string; crop?: CropData } {
  if (!url) return { cleanUrl: '' };
  const [cleanUrl, hash] = url.split('#');
  if (!hash || !hash.startsWith('crop=')) {
    return { cleanUrl };
  }
  const parts = hash.replace('crop=', '').split(',').map(Number);
  if (parts.length >= 6 && parts.every(n => !isNaN(n) && isFinite(n))) {
    const [x, y, width, height, naturalWidth, naturalHeight] = parts;
    if (width > 0 && height > 0 && naturalWidth > 0 && naturalHeight > 0) {
      return {
        cleanUrl,
        crop: { x, y, width, height, naturalWidth, naturalHeight },
      };
    }
  }
  return { cleanUrl };
}

export function getFramedImageStyles(crop?: CropData): {
  containerStyle: React.CSSProperties;
  imageStyle: React.CSSProperties;
} {
  if (!crop) {
    return {
      containerStyle: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: 2,
      },
      imageStyle: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    };
  }

  const cropRatio = crop.width / crop.height;
  const widthPercent = (crop.naturalWidth / crop.width) * 100;
  const heightPercent = (crop.naturalHeight / crop.height) * 100;
  const leftPercent = -(crop.x / crop.width) * 100;
  const topPercent = -(crop.y / crop.height) * 100;

  return {
    containerStyle: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 'auto',
      aspectRatio: `${cropRatio}`,
      maxHeight: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      zIndex: 2,
    },
    imageStyle: {
      position: 'absolute',
      top: `${topPercent}%`,
      left: `${leftPercent}%`,
      width: `${widthPercent}%`,
      height: `${heightPercent}%`,
      maxWidth: 'none',
      maxHeight: 'none',
      objectFit: 'fill',
    },
  };
}
